import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ss-form-validation',
  templateUrl: './form-validation.component.html',
  styleUrls: ['./form-validation.component.scss'],
  standalone: false
})
export class FormValidationComponent implements OnInit {
  @Input() message: string = "";
  @Input() field!: FormControl;

  constructor() { }

  ngOnInit() { }

}
